"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.hierarchyItemLength = exports.infoLength = void 0;
exports.infoLength = 160;
exports.hierarchyItemLength = 32;
